var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-6" }, [
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "" } }, [_vm._v("Поставщик")]),
          _vm._v(" "),
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              staticClass: "form-control",
              attrs: { type: "text", disabled: "" },
              domProps: { value: _vm.invoice.supplier.title },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "input-group-prepend" }, [
              _c("span", { staticClass: "input-group-text" }, [
                _vm._v(
                  _vm._s(_vm.$AllCurrencies[_vm.invoice.currency_id].currency)
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group" }, [
          _c("label", { attrs: { for: "" } }, [_vm._v("Комментарий")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.invoice.comment,
                expression: "invoice.comment",
              },
            ],
            staticClass: "form-control",
            attrs: { type: "text", placeholder: "Комментарий к закупке" },
            domProps: { value: _vm.invoice.comment },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.invoice, "comment", $event.target.value)
              },
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-md-6" },
        [_c("InvoiceDiscount", { attrs: { invoice: _vm.invoice } })],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }